import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "news-area-title" }
const _hoisted_3 = { class: "news-area-body" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';

interface Props {
  // 表示画面(ログイン：0 TOP：1)
  displayScreen: string;
}

interface News {
  news_id: string;
  publish_date: string;
  news_title: string;
  news_body: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NewsAreaScroll',
  props: {
    displayScreen: {}
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();

// お知らせ情報
let news: News[] = [];

// Skeletonフラグ
const isSkeleton = ref(true);

/**
 * お知らせ情報取得
 */
const getNewsInfo = async () => {
  // 検索条件設定
  const formData = new FormData();
  formData.append('display_screen', props.displayScreen);

  // お知らせ情報取得
  await axios
    .post('/news', formData)
    .then((res) => {
      const { common, newsInfoList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          news = newsInfoList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // 必須入力エラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch(() => {
      // エラー画面に遷移
      router.push({ name: 'error' });
    })
    .finally(() => {
      isSkeleton.value = false;
    });
};

/**
 * 初期処理
 */
getNewsInfo();

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('q-ma-lg news-area ' + (_ctx.displayScreen === '0' ? 'login' : ''))
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("label", null, "お知らせ", -1)),
    (isSkeleton.value)
      ? (_openBlock(), _createBlock(_component_q_skeleton, {
          key: 0,
          square: "",
          class: "news-area-skeleton"
        }))
      : (_openBlock(), _createBlock(_component_q_scroll_area, {
          key: 1,
          class: "news-area-scroll",
          visible: ""
        }, {
          default: _withCtx(() => [
            (_unref(news).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, "現在新たなお知らせはありません。"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.news_id,
                class: "column q-pb-md"
              }, [
                _createVNode(_component_q_separator, {
                  color: "secondary",
                  size: "2px",
                  class: "q-mb-sm"
                }),
                _createElementVNode("p", null, _toDisplayString(item.publish_date), 1),
                _createElementVNode("label", _hoisted_2, _toDisplayString(item.news_title), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.news_body), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }))
  ], 2))
}
}

})